<template>
    <div class="app-thinking-text">
        <span class="thinking-text__item--no">思考中，请稍后</span>
        <span class="thinking-text__item">。</span>
        <span class="thinking-text__item">。</span>
        <span class="thinking-text__item">。</span>
        <span class="thinking-text__item">。</span>
        <span class="thinking-text__item">。</span>
        <span class="thinking-text__item">。</span>
    </div>
</template>

<script>
export default {
    name: 'app-thinking-text'
};
</script>

<style scoped lang="scss">
.app-thinking-text {
    display: flex;
    align-items: center;
    .thinking-text__item {
        opacity: 0;
        animation: change 0.3s ease infinite alternate;
    }
    .thinking-text__item:nth-of-type(1) {
        animation-delay: 0.1s;
    }
    .thinking-text__item:nth-of-type(2) {
        animation-delay: 0.2s;
    }
    .thinking-text__item:nth-of-type(3) {
        animation-delay: 0.3s;
    }
    .thinking-text__item:nth-of-type(4) {
        animation-delay: 0.4s;
    }
    .thinking-text__item:nth-of-type(5) {
        animation-delay: 0.5s;
    }
    .thinking-text__item:nth-of-type(6) {
        animation-delay: 0.6s;
    }
    .thinking-text__item:nth-of-type(7) {
        animation-delay: 0.7s;
    }
    @keyframes change {
        100% {
            opacity: 1;
        }
    }
}
</style>
